const Version = () => {
    const versionSystem = process.env.REACT_APP_VERSION || "V1.855.0.20221111";
    return (
        <div
            style={{
                position: "fixed",
                bottom: "5px",
                right: "5px",
                color: "#42464aff",
                fontSize: "0.6rem",
                opacity: 0.5,
            }}
        >
            {versionSystem}
        </div>
    );
};

export default Version;
